import React from 'react';
import { tone, fmtQty } from './ageingUtils';

// Ageing mix bar + one clickable card per age range (opens its item list).
export const AgeingBucketStrip = ({ report, onPick }) => {
  const n = report.buckets.length;
  const main = report.totals[0];
  const extra = report.totals.slice(1);
  const cols = [...report.buckets.map((b) => ({ ...b, key: b.index })),
    ...(report.has_undated ? [{ index: -1, label: 'No date', key: 'undated' }] : [])];
  const cellOf = (t, idx) => (idx < 0 ? t.undated : t.cells[idx]) || { qty: 0, count: 0 };
  const grand = main?.total_qty || 0;

  return (
    <div className="space-y-3" data-testid="ageing-bucket-strip">
      <div className="h-3 w-full rounded-full overflow-hidden flex bg-stone-200" data-testid="ageing-mix-bar">
        {main && cols.map((c) => {
          const q = cellOf(main, c.index).qty;
          return q > 0 ? (
            <div key={c.key} className={`${tone(c.index, n).bar} transition-[width] duration-500`}
              style={{ width: `${(q / grand) * 100}%` }} title={`${c.label}: ${fmtQty(q)}`} />
          ) : null;
        })}
      </div>
      <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1 snap-x sm:grid sm:grid-cols-4 lg:grid-cols-9 sm:overflow-visible sm:pb-0" data-testid="ageing-bucket-cards">
        {cols.map((c, i) => {
          const cell = main ? cellOf(main, c.index) : { qty: 0, count: 0 };
          const raw = grand ? (cell.qty / grand) * 100 : 0;
          const pct = raw > 0 && raw < 1 ? '<1' : Math.round(raw);
          return (
            <button key={c.key} type="button" onClick={() => onPick(c.index)}
              className={`shrink-0 min-w-[140px] snap-start sm:min-w-0 text-left rounded-lg border border-stone-200 border-t-4 ${tone(c.index, n).edge} bg-white px-3 py-2.5 hover:-translate-y-0.5 hover:shadow-md transition-[transform,box-shadow] duration-200 animate-in fade-in slide-in-from-bottom-1`}
              style={{ animationDelay: `${i * 40}ms` }}
              data-testid={`ageing-bucket-card-${c.key}`}>
              <p className="text-[11px] font-semibold uppercase tracking-wide text-stone-500">{c.label}{c.index >= 0 ? ' days' : ''}</p>
              <p className="text-xl font-bold tabular-nums text-stone-900 mt-0.5" data-testid={`ageing-bucket-qty-${c.key}`}>{fmtQty(cell.qty)}</p>
              <p className="text-xs text-stone-500 tabular-nums">
                {report.storage === 'fg' ? `${pct}% of pieces` : `${fmtQty(cell.count)} ${cell.count === 1 ? 'bundle' : 'bundles'} · ${pct}%`}
              </p>
              {extra.map((t) => cellOf(t, c.index).qty > 0 && (
                <p key={t.unit} className="text-xs font-medium text-stone-700 tabular-nums">+ {fmtQty(cellOf(t, c.index).qty)} {t.unit}</p>
              ))}
            </button>
          );
        })}
      </div>
    </div>
  );
};
